import styled from 'styled-components'
import { Button, ButtonBase, styled as muiStyled } from '@mui/material'

export const GoalsCard = muiStyled('div')(({ theme }) => ({
  display: 'flex',
  borderRadius: '14px',
  overflow: 'hidden',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  textAlign: 'center',
  gap: '6px',
  padding: '14px',
  background: 'linear-gradient(180deg, #e8e8e8 0%, #d4d4d4 100%)',
  height: '220px',
  width: '100%',
  position: 'relative',
  boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
  border: '1px solid rgba(255,255,255,0.5)',
  transition: 'box-shadow 0.2s ease',
  '&:hover': {
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
  },
  [theme.breakpoints.up('sm')]: {
    height: '260px',
    padding: '16px',
  },
  [theme.breakpoints.up('md')]: {
    height: '300px',
    borderRadius: '16px',
    padding: '18px',
  },
  [theme.breakpoints.up('lg')]: {
    height: '320px',
  },
}))

export const GoalImage = styled.img`
  width: 100%;
  height: 55%;
  min-height: 100px;
  object-fit: cover;
  border-radius: 10px;
`

export const GoalSlide = muiStyled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  margin: 0,
  position: 'relative',
  height: '300px',
  [theme.breakpoints.up('sm')]: {
    height: '340px',
  },
  [theme.breakpoints.up('md')]: {
    height: '380px',
  },
  [theme.breakpoints.up('lg')]: {
    height: '400px',
  },
}))

export const GoalSlideTitle = styled.div`
  color: #1a0068;
  font-family: Outfit;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.3;

  @media (min-width: 576px) {
    font-size: 16px;
  }
  @media (min-width: 768px) {
    font-size: 18px;
  }
`
export const OrganizationalGoalsHeading = styled.div`
  color: #fff;
  font-size: 28px;
  font-weight: 500;
`
export const AddOrganizationalGoalsButton = muiStyled(ButtonBase)(({ theme }) => ({
  background: 'linear-gradient(135deg, #00267A 0%, #003a9e 100%)',
  color: '#fff',
  display: 'flex',
  borderRadius: '10px',
  justifyContent: 'space-between',
  padding: '10px 18px',
  gap: '12px',
  boxShadow: '0 2px 12px rgba(0, 38, 122, 0.35)',
  transition: 'transform 0.15s ease, box-shadow 0.2s ease',
  '&:hover': {
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 16px rgba(0, 38, 122, 0.4)',
  },
}))

export const GoalsSubtext = styled.div`
  color: #8570c5;
  font-size: 11px;
  font-weight: 400;

  @media (min-width: 768px) {
    font-size: 12px;
  }
`
export const GoalsProgressTextHeading = styled.div`
  color: #fff;
  font-size: 18px;
  font-weight: 700;

  @media (min-width: 768px) {
    font-size: 20px;
  }
`
export const GoalsProgressTextSubHeading = styled.div`
  color: #fff;
  font-size: 9px;
  font-weight: 300;

  @media (min-width: 768px) {
    font-size: 10px;
  }
`
export const GoalsProgressContainer = styled.div`
  position: absolute;
  border-radius: 100%;
  border: 4px solid #2256c8;
  background: linear-gradient(135deg, #487bed 0%, #2256c8 100%);
  bottom: 16px;
  height: 72px;
  width: 72px;
  box-shadow: 0 4px 24px rgba(34, 86, 200, 0.4);
  filter: drop-shadow(2px 3px 12px rgba(0, 0, 0, 0.15));

  @media (min-width: 576px) {
    bottom: 20px;
    height: 80px;
    width: 80px;
  }
  @media (min-width: 768px) {
    bottom: 24px;
    height: 88px;
    width: 88px;
  }
  @media (min-width: 992px) {
    bottom: 28px;
    height: 96px;
    width: 96px;
  }
`
